module.exports = __webpack_public_path__ + "img/chevron-down.225c62b5.svg";